import useAuthStore from '@/store/auth'
import useCentralStore from '@/store/central'
import useUserStore from '@/store/user'

export function clearDataStores() {
  const { clear: clearUserStore } = useUserStore()
  const { clear: clearAuthStore } = useAuthStore()
  const { clear: clearCentralStore } = useCentralStore()

  clearUserStore()
  clearAuthStore()
  clearCentralStore()
}
